log = require 'loglevel'
Tween = require 'tween'
BaseButton = require 'BaseButton'
SingleScratchView = require 'singleScratchView'
currencyManager = require 'currencyManager'
eventManager = require 'eventManager'
imageManager = require 'imageManager'
layoutManager = require 'layoutManager'
realityManager = require 'realityManager'
soundManager = require 'soundManager'
gameModel = require 'gameModel'
imageModel = require 'imageModel'

class GameView extends PIXI.Container

  name: 'GameView'
  gameOver: true
  resultShown: true
  flakeThrottling: 50
  canDropFlakes: true
  isReplay: false

  tweens: []
  timer: null
  realityCheckTimer: null
  canClick: false
  finalPrizeY: 300
  bgWinAlpha: 0.4
  bgLossAlpha: 0
  signYOffset: -200

  ticketStyle:
    fontFamily: "Courier"
    fontWeight: 100
    fontSize: 8
    fill: "#FFFFFF"
    lineHeight: 15

  style:
    fontSize: 22
    fill: "#FFFFFF"
    align: "center"
    lineHeight: 32
    dropShadow: true,
    dropShadowBlur: 20,
    dropShadowColor: '#000000',
    dropShadowAngle: Math.PI/2,
    dropShadowDistance: 1
    padding: 10

  amountStyle:
    fontSize: 56
    fontWeight: 700
    fill: "#FFFFFF"
    align: "center"
    lineHeight: 60

  menuStyle:
    fontWeight: 100
    fontSize: 12
    fill: "#FFFFFF"
    lineHeight: 15
    lineJoin: 'round',
    # dropShadow: true,
    # dropShadowBlur: 20,
    # dropShadowColor: '#000000',
    # dropShadowAngle: Math.PI/2,
    # dropShadowDistance: 1
    padding: 10
    stroke: 'rgba(0,0,0,0.7)',
    strokeThickness: 3,


  lastWinStyle:
    fontSize: 12
    fontWeight: 400
    wordWrap:  false
    lineHeight:  15
    padding: 2
    lineJoin: 'round',
    # dropShadow: true,
    # dropShadowBlur: 20,
    # dropShadowColor: '#000000',
    # dropShadowAngle: Math.PI/2,
    # dropShadowDistance: 1
    stroke: 'rgba(0,0,0,0.7)',
    strokeThickness: 3,

  #----------------------------------------------

  initSetup: (cb) ->
    log.info @constructor.name, 'initSetup'

    eventManager.listenTo 'scratching', (data) => @dropFlakes(data)

    @style.fontFamily =  gameModel.getSecondaryFont()
    @amountStyle.fontFamily = gameModel.getFont()
    @amountStyle.fontSize = gameModel.winSignTextMaxFontSize
    @menuStyle.fontFamily = gameModel.getFont()
    @replayStyle = gameModel.styles.introText
    @lastWinStyle.fill = gameModel.primaryColor

    @titleLossY = gameModel.titleLossY

    # useful for seeing the inner stage
    # rect = new PIXI.Graphics()
    # rect.beginFill(0x000000)
    # rect.drawRect(0,0,gameModel.gameWidth,gameModel.gameHeight)
    # rect.endFill()
    # rect.alpha = 0.4
    # @addChild(rect)

    @addLogo() if gameModel.showLogoInGame
    @addButton()
    @addScratch ->
      cb() if cb?

    @addConfetti()
    @addWinSign()
    @addLostText()

    return unless gameModel.getShowTicketId()

    @addTicketText()

    return


  #----------------------------------------------

  resetAfterNotification: ->
    @gameOver = true
    @resultShown = true
    @enableInteraction()
    # @playButton.updateText __t.str("Play now")
    # @scratchView.reset() if @scratchView?

  #----------------------------------------------

  buttonClick: ->

    return if not @canClick
    @disableInteraction()

    # End of replay
    return @endOfReplayClick() if @isReplay

    # Scratch all
    return @scratchAll() if not @gameOver

    # Show reality check if needed
    return if @showRealityFirst()

    # Place Bet
    @placeNewBet()

  # -------------------------------------------

  placeNewBet: ->

    @skipResultAnimation()
    @hideResult()
    @disableInteraction()
    eventManager.trigger 'place-bet'

  # -------------------------------------------

  endOfReplayClick: ->
    @showStart()
    @removeEndOfReplay()
    @disableInteraction()
    eventManager.trigger 'end-replay'

  # -------------------------------------------

  executeBet:(betModel, err, code, cb) ->

    if err? or not betModel?
      @betModel = null
      return

    @betModel = betModel
    ticketId = @betModel.getTicketId()

    @setupWithTicket @betModel, =>
      eventManager.trigger 'balance', @betModel.getBalanceBefore()
      eventManager.trigger 'tickets', @betModel.getRoundsLeftAfter()
      cb() if cb?

  # -------------------------------------------

  setupWithTicket: (@betModel, cb, @isReplay = false) ->

    @gameOver = false
    @resultShown = false

    @lossTitleText.visible = false
    @menuButton.visible = false if @menuButton?
    @updateTicktId @betModel.getTicketId()

    @scratchView.setupWithTicket @betModel, =>

      if @isReplay
        @disableInteraction()
        setTimeout( =>
          @scratchAll()
        ,1000)
      else
        @playButton.updateText __t.str("Scratch all")
        @enableInteraction()

      @scratchView.allowScratching()

      cb()

  #----------------------------------------------

  endGame: (winningPrizes) ->
    log.info @constructor.name, 'endGame'

    @gameOver = true

    @playButton.updateText(__t.str('Okay')) if @isReplay

    isWinner = @betModel.isWin()
    prizeId = @betModel.getWinIndex()
    ticketId = @betModel.getTicketId()
    roundsLeft = @betModel.getRoundsLeftAfter()
    winAmount = @betModel.getTotalWinAmount()
    balanceAfter = @betModel.getBalanceAfter()
    hasNoTickets = (roundsLeft <= 0 and gameModel.isBasketMode() and not @betModel.isReplay)
    gameModel.setRoundsLeft roundsLeft unless @betModel.isReplay

    eventManager.trigger 'balance', balanceAfter
    eventManager.trigger 'end-round', {
      ticketId:ticketId
      winAmount:winAmount
      balanceAfter:balanceAfter
      roundsLeft:roundsLeft
    }

    @enableInteraction()

    @showResult isWinner, winAmount, ticketId, prizeId, @betModel.isReplay, hasNoTickets, =>
      @resultShown = true

      if gameModel.isOutOfTickets()
        eventManager.trigger 'no-tickets-left'

    # if isWinner
    #   for prize in winningPrizes
    #     @showLastWin prize.x, prize.y, winAmount


  # -------------------------------------------

  showLastWin: (x,y,amount) ->

    y = y + gameModel.scratchY

    amount = currencyManager.localize amount
    lastWin = new PIXI.Text amount, @lastWinStyle
    lastWin.alpha = 1
    lastWin.centerAtPoint(x,y)
    @addChild lastWin

    midX = x + 100
    midY = y - 100
    finalX = gameModel.rendererWidth - ((gameModel.rendererWidth-gameModel.gameWidth)/2) - 50
    finalY = gameModel.rendererHeight - 40


    to =
      bezier:
        type:"soft"
        values:[{x:midX, y:midY},{x:finalX, y:finalY}]
      ease: Power2.easeIn

      onComplete: ->
        lastWin.removeSelf()

    Tween.to(lastWin, 1, to)

  #----------------------------------------------

  showResult: (isWinner, winAmount, ticketId, prizeId, isReplay, hasNoTickets, cb) ->

    if isReplay
      @playButton.updateText __t.str("Okay")
    else
      @playButton.updateText __t.str("Play again")

    if isWinner
      key = gameModel.getSoundForPrizeId(prizeId)
      soundManager.win(key)
      time = 1500
    else
      soundManager.loss()
      time = 1

    @timer = setTimeout( =>

      if isWinner
        @updateWinText winAmount

        @playWinSign =>
          eventManager.trigger 'won', winAmount
          realityManager.canShowRealityCheck true
          cb()

        if prizeId >= gameModel.bigWinStartingPrizeId
          soundManager.bigWin()
          @playConfetti()

      else
        @lossTitleText.visible = true
        @lossTitleText.bringToFront()
        @realityCheckTimer = setTimeout(->
          realityManager.canShowRealityCheck true
        , time + 1000)
        cb()

      @addMenuButton()
      @addEndOfReplay() if isReplay

    , time)

  #----------------------------------------------

  hideResult: ->
    clearTimeout @timer

    @menuButton.visible = false if @menuButton?
    @lossTitleText.visible = false if @lossTitleText?
    @winSignContainer.visible = false if @winSignContainer?

    @stopConfetti()
    @stopWinSign()
    @removeEndOfReplay()

    @resultShown = false

  #----------------------------------------------

  scratchAll: (cb) ->
    log.info @constructor.name, 'scratchAll'

    @scratchView.scratchAll =>
      cb() if cb?

  # -------------------------------------------

  spacebarHit: ->

    return unless @canClick
    @buttonClick(false)

  #----------------------------------------------

  skipResultAnimation: ->

    return if @resultShown
    return unless @gameOver

    @canContinuePlaying()

    if @betModel.isWin()
      @showWinResult()

    else
      @showLossResult()

    if gameModel.isOutOfTickets()
      eventManager.trigger 'no-tickets-left'

    delete @betModel

  # -------------------------------------------

  showWinResult: ->

    @resultShown = true
    @stopConfetti()
    @stopWinSign()

    t.kill() for t in @tweens
    soundManager.stopBigWin()

    clearTimeout @timer
    clearTimeout @realityCheckTimer

    @winSignContainer.visible = false
    @playButton.updateText __t.str("Play again")
    @menuButton.visible = true if @menuButton?
    @enableInteraction()

  # -------------------------------------------

  showLossResult: ->

    @resultShown = true

    clearTimeout @timer
    clearTimeout @realityCheckTimer

    @lossTitleText.visible = true
    @playButton.updateText __t.str("Play again")
    @menuButton.visible = true if @menuButton?
    @enableInteraction()

  # -------------------------------------------

  showStart: ->

    clearTimeout @timer
    clearTimeout @realityCheckTimer

    @disableInteraction()
    @scratchView.reset() if @scratchView?

    @menuButton.visible = false if @menuButton?
    @lossTitleText.visible = false if @lossTitleText?
    @winSignContainer.visible = false if @winSignContainer?

    @stopConfetti()
    @stopWinSign()
    @removeEndOfReplay()

    if soundManager.isSetup()
      soundManager.stopWin()
      soundManager.stopBigWin()

    @resultShown = false

  # -------------------------------------------

  canContinuePlaying: ->
    res = true
    if gameModel.isOutOfTickets() and gameModel.shouldShowBuyMorePopup()
      @disableInteraction()
      res = false
    res

  # -------------------------------------------

  enableInteraction: ->

    # if we still have tickets or we are meant to show buy more pop
    # renable the game

    return if gameModel.isOutOfTickets() and not gameModel.shouldShowBuyMoreButton()

    @canClick = true

    if @playButton?
      @playButton.enable()
      @playButton.visible = true


  # -------------------------------------------

  disableInteraction: ->

    @canClick = false

    if @playButton?
      @playButton.disable()
      @playButton.visible = false

  # -------------------------------------------

  addLogo: (cb) ->
    log.info @constructor.name, 'addLogo'

    url = imageModel.logoGameImage
    imageManager.loadAsset url, (image) =>
      @logo = new PIXI.Sprite.fromImage url
      @logo.x = Math.round((gameModel.gameWidth - @logo.width)/2)
      @logo.y = gameModel.logoYInGame
      @addChild @logo
      cb() if cb?

  #----------------------------------------------

  addScratch: (cb) ->
    log.info @constructor.name, 'addScratch'

    y = gameModel.scratchY

    @scratchView =  new SingleScratchView(gameModel.gameWidth, gameModel.gameHeight, y)

    @scratchView.initSetup (x,y,w,h)=>
      @scratchView.x = x
      @scratchView.y = y
      @addChild @scratchView
      cb()

    @scratchView.willClearAfterUserScratchedManually = =>
      @disableInteraction()
      eventManager.trigger 'will-reveal-all'


  #----------------------------------------------

  addButton: (cb) ->
    log.info @constructor.name, 'addButton'

    options =
      text: __t.str('Play again')
      shadow: true
      type: 'primary'
      buttonImage: imageModel.buttonImage if gameModel.hasButtonImage
      buttonHoverImage: imageModel.buttonHoverImage if gameModel.hasButtonImage


    @playButton =  new BaseButton(options)
    @playButton.tapped = (e) => @buttonClick(false)
    @playButton.order = 0

    layoutManager.placeButton @playButton
    @addChild @playButton

  #----------------------------------------------

  addConfetti: ->

    return if @confetti?
    textureArray = imageManager.makeTexturesFromName 'confetti'
    @confetti = new PIXI.extras.AnimatedSprite(textureArray)
    @confetti.anchor.y = 1
    @confetti.y = gameModel.rendererHeight
    @confetti.loop = false
    @confetti.animationSpeed = 0.40
    @confetti.visible = false

    __renderer.plugins.prepare.upload @confetti,=>
      @addChild @confetti

    @confetti.onComplete = =>
      @stopConfetti()

  #----------------------------------------------

  playConfetti: ->

    @confetti.alpha = 1
    @confetti.visible = true
    @confetti.bringToFront()
    @confetti.x = 0

    setTimeout(=>
      @confetti.gotoAndPlay(0)
    ,0)

  #----------------------------------------------

  stopConfetti: ->

    @confetti.gotoAndStop(0)
    @confetti.visible = false

  #----------------------------------------------

  addWinSign: ->

    return if @winSign?

    @winSignContainer = new PIXI.Container()
    @winSignContainer.width = gameModel.gameWidth
    @winSignContainer.visible = false
    @winSignContainer.y = @signYOffset
    @addChild @winSignContainer

    if gameModel.winSign is 'movie'
      @textureArray = imageManager.makeTexturesFromName 'result'

      tmp = []
      pattern = [2,3,4,2,3,4,2,3,4,0,1,0,1,0]
      for i in pattern
        tmp.push @textureArray[i]

      @winSign = new PIXI.extras.AnimatedSprite(tmp)
      @winSign.loop = true
      @winSign.animationSpeed = 0.07
      @winSign.gotoAndPlay(0)
      @winSignContainer.addChild @winSign
      @winSign.centerX(gameModel.gameWidth)

      __renderer.plugins.prepare.upload(@winSign)

    if gameModel.winSign is 'image'
      @winSign = new PIXI.Sprite.fromImage(imageModel.winSignImage)
      @winSignContainer.addChild @winSign
      @winSign.centerX(gameModel.gameWidth)


    @winTitleText = new PIXI.Text __t.str('You Won!'), @style
    @winTitleText.y = gameModel.winSignTextY
    @winTitleText.style = @style
    @winTitleText.clarify()
    @winTitleText.centerX(gameModel.gameWidth)
    @winSignContainer.addChild @winTitleText

    @amountText = new PIXI.Text @amount, @amountStyle
    @amountText.y = gameModel.winSignTextY + 15
    @winSignContainer.addChild @amountText

  #----------------------------------------------

  playWinSign:(cb) ->

    @winSignContainer.y = @signYOffset
    @winSignContainer.bringToFront()

    to =
      y: gameModel.winSignYOffset
      ease: Back.easeOut.config(1.3)
      yoyo: true
      repeat: 1
      repeatDelay:2.5
      onComplete: ->
        cb() if cb

    @tweens.push Tween.to(@winSignContainer, 0.4, to)

    @winSignContainer.visible = true

    if gameModel.winSign is 'movie'

      setTimeout(=>
        @winSign.play()
      ,0)

  #----------------------------------------------

  stopWinSign: ->
    if gameModel.winSign is 'movie'
      @winSign.gotoAndStop(0)

  #----------------------------------------------

  updateWinText: (amount) ->
    amount = currencyManager.localize amount
    @amountText.text = amount
    @amountText.style.fontSize = gameModel.winSignTextMaxFontSize

    @amountText.sizeToFit(gameModel.winSignTextMaxWidth,false)
    @amountText.clarify()
    @amountText.centerAtPoint(gameModel.gameWidth/2, gameModel.winSignTextY + 20 + (@amountText.height/2))

  #----------------------------------------------

  addLostText: ->

    @lossTitleText = new PIXI.Text __t.str('Better luck next time...'), @style
    @lossTitleText.y = @titleLossY
    @lossTitleText.style = @style
    @lossTitleText.clarify()
    @lossTitleText.centerX(gameModel.gameWidth)
    @lossTitleText.visible = false
    @addChild @lossTitleText

  #----------------------------------------------

  dropFlakes: (data) ->
    return unless @canDropFlakes

    @canDropFlakes = false
    @_dropFlakes(data)

    setTimeout( =>
      @canDropFlakes = true
    , @flakeThrottling * Math.random())

  # -------------------------------------------

  _dropFlakes: (data) ->

    url = imageModel.flakeImage
    flake = new PIXI.Sprite.fromImage url

    x = data.x + (Math.random() * 60) - 30
    y = data.y + (Math.random() * 60) - 30
    dir = x + (data.dir*2)

    flake.scale.set (Math.random() + 0.7)/2, (Math.random() + 0.7)/2
    flake.anchor.set 0.5, 0.5
    flake.position.set x, y
    @addChild flake

    to =
      y: 800
      x: dir
      alpha: 0
      rotation: Math.random() * 10 - 5
      onComplete: ->
        flake.removeSelf()

    Tween.to(flake, 2000/1000, to)

  #----------------------------------------------

  addTicketText: ->

    return unless gameModel.getShowTicketId()

    if @ticketText?
      @updateTicktId ''
      @ticketText.visible = true
      return

    @ticketText = new PIXI.Text '', @ticketStyle
    @ticketText.y = 10
    @ticketText.alpha = 0.7
    @addChild @ticketText
    @updateTicktId ''

  #----------------------------------------------

  updateTicktId: (ticketId) ->

    return unless gameModel.getShowTicketId()
    return if not ticketId?

    if ticketId is 0
      ticketId = 'DEMO'
    else if ticketId is ''
      ticketId = ''
    else
      ticketId = "#" + ticketId

    @ticketText.text = ticketId
    @ticketText.clarify()
    @ticketText.y = 320
    @ticketText.x = gameModel.gameWidth - 20 + gameModel.ticketIdX
    @ticketText.rotation = (-90)*(Math.PI/180)

  #----------------------------------------------

  addMenuButton: (cb) ->
    # # log.info @constructor.name, 'addMenuButton'
    # if @menuButton?
    #   @menuButton.visible = true
    #   @menuButton.interactive = true
    #   @menuButton.buttonMode = true
    #   return

    # offset = -(gameModel.rendererWidth - gameModel.gameWidth) / 2 + 10

    # text = __t.str 'Menu'
    # text = '‹ '+text
    # @menuButton =  new PIXI.Container()
    # @menuButton.interactive = true
    # @menuButton.buttonMode = true
    # menuLabel = new PIXI.Text(text,@menuStyle)
    # @menuButton.position.set(offset,10)
    # @menuButton.addChild(menuLabel)
    # @menuButton.visible = false if @isReplay
    # @addChild @menuButton

    # @menuButton.mouseup = (e) -> @tapped e
    # @menuButton.touchend = (e) -> @tapped e
    # @menuButton.tapped = (e) =>
    #   e.stopPropagation()
    #   @menuButtonClick(e)

  # -------------------------------------------

  # menuButtonClick: (e) ->

  #   return if @showRealityFirst()

  #   eventManager.trigger 'show-menu'

  #   @skipResultAnimation()

  #   if @noTicketsLeft
  #     eventManager.trigger 'no-tickets-left'
  #     return

  #----------------------------------------------

  addEndOfReplay: ->
    @replayText = new PIXI.Text __t.str('Replay finished'), @replayStyle
    @replayText.y = gameModel.gameHeight - 140
    @addChild @replayText
    @replayText.clarify()
    @replayText.centerX(gameModel.gameWidth)

  #----------------------------------------------

  removeEndOfReplay: ->
    @isReplay = false
    return unless @replayText?
    @replayText.removeSelf()
    @replayText = null

  # -------------------------------------------

  showRealityFirst: ->
    # do we need to show it
    if realityManager.needsToShowRealityCheck
      realityManager.canShowRealityCheck true
      return true

    false

  #----------------------------------------------

  resize: ->
    layoutManager.repositionY @playButton

    if @menuButton?
      @menuButton.x = -(gameModel.rendererWidth - gameModel.gameWidth) / 2 + 10

  # -------------------------------------------

module.exports = GameView


// WEBPACK FOOTER //
// ./coffee/view/game-view.coffee